import { createBrowserHistory, createMemoryHistory } from 'history';
import { updateReferrer } from '@wix/da-bi/pkg/referrer';
import { duperbrowseHistoryChanged, historyChanged } from './actions';
import { isDuperbrowseLocation } from '../../Duperbrowse/redux/helpers';
function createHistory() {
    if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
        return createMemoryHistory();
    } else {
        return createBrowserHistory();
    }
}
const baseHistoryInstance = createHistory();
function filteredHistoryListen(listener) {
    return baseHistoryInstance.listen((location, action)=>{
        // ignore all duperbrowse locations
        if (isDuperbrowseLocation(location)) {
            return;
        }
        listener(location, action);
    });
}
// This is a weird special case that allows us to avoid sending history
// events for duperbrowse urls, in particular to stop react-router from
// getting confused while duper is active.
const routerSafeHistory = new Proxy(baseHistoryInstance, {
    get (target, prop, receiver) {
        if (prop === 'listen') {
            return filteredHistoryListen;
        }
        // try not to fuck up other props
        const targetProp = Reflect.get(target, prop, receiver);
        if (typeof targetProp === 'function') {
            return (...args)=>targetProp.call(target, ...args);
        }
        return targetProp;
    }
});
export function configureHistoryListener(store) {
    const unlisten = baseHistoryInstance.listen((location, action)=>{
        updateReferrer();
        isDuperbrowseLocation(location) ? store.dispatch(duperbrowseHistoryChanged(location, action)) : store.dispatch(historyChanged(location, action));
    });
    return unlisten;
}
export default baseHistoryInstance;
export { routerSafeHistory };
